import * as fromDatatype from '../datatype-library/index'

export interface bl_mrp_process_template_bom_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    bl_mrp_process_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_line_guid:fromDatatype.GuidDataFieldInterface;
    txn_type:fromDatatype.VarcharDatatypeInterface;
    ccy_code:fromDatatype.VarcharDatatypeInterface;
    ccy_xrate:fromDatatype.NumericDatatypeInterface;
    logic:fromDatatype.VarcharDatatypeInterface;
    code:fromDatatype.VarcharDatatypeInterface;
    name:fromDatatype.VarcharDatatypeInterface;
    descr:fromDatatype.TextDatatypeInterface;
    scan_code:fromDatatype.VarcharDatatypeInterface;
    sub_item_type:fromDatatype.VarcharDatatypeInterface;
    uom:fromDatatype.VarcharDatatypeInterface;
    amount:fromDatatype.NumericDatatypeInterface;
    ratio:fromDatatype.NumericDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    options_json:fromDatatype.JsonDatatypeInterface;
    log_json:fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid:fromDatatype.GuidDataFieldInterface; 
    acl_config:fromDatatype.JsonDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    namespace:fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date:fromDatatype.TimestampTzDatatypeInterface;
    status:fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn:fromDatatype.VarcharDatatypeInterface;
};

export class bl_mrp_process_template_bom_RowClass implements bl_mrp_process_template_bom_RowInterface
  {
    guid: fromDatatype.GuidDataFieldInterface;
    bl_mrp_process_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_line_guid:fromDatatype.GuidDataFieldInterface;
    txn_type:fromDatatype.VarcharDatatypeInterface;
    ccy_code:fromDatatype.VarcharDatatypeInterface;
    ccy_xrate:fromDatatype.NumericDatatypeInterface;
    logic:fromDatatype.VarcharDatatypeInterface;
    code:fromDatatype.VarcharDatatypeInterface;
    name:fromDatatype.VarcharDatatypeInterface;
    descr:fromDatatype.TextDatatypeInterface;
    scan_code:fromDatatype.VarcharDatatypeInterface;
    sub_item_type:fromDatatype.VarcharDatatypeInterface;
    uom:fromDatatype.VarcharDatatypeInterface;
    amount:fromDatatype.NumericDatatypeInterface;
    ratio:fromDatatype.NumericDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    options_json:fromDatatype.JsonDatatypeInterface;
    log_json:fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid:fromDatatype.GuidDataFieldInterface; 
    acl_config:fromDatatype.JsonDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    namespace:fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date:fromDatatype.TimestampTzDatatypeInterface;
    status:fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn:fromDatatype.VarcharDatatypeInterface;
  }
